module.exports = __webpack_public_path__ + "img/92182.4b91e080.svg";